module.exports = __webpack_public_path__ + "static/media/circle-high.87333e01.svg";